import { useTheme, useMediaQuery } from '@mui/material';
import TicketCreatePageDesktop from './TicketCreatePageDesktop';
import TicketCreatePageMobile from './TicketCreatePageMobile';

export default function TicketCreatePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <TicketCreatePageMobile />
    : <TicketCreatePageDesktop />;
}